import { createMessengerConnectionHSM } from './messenger-connection-hsm.js';
import { createConsoleLogger } from './../utils.js';

export class MessengerConnection {

  constructor(messenger, me, collocutor, imChatInfo) {
    this.messenger = messenger;
    this.me = me;
    this.collocutor = collocutor;
    this.imChatInfo = imChatInfo;

    const logger = this.logger = createConsoleLogger(true, 'IMConn (' + collocutor.username + '):');

    const hsm = this.hsm = createMessengerConnectionHSM(this, me, collocutor, messenger.edgeConnection);
    messenger.edgeConnection.attach_im_hsm(hsm);

    this.socket = {};
    this.socket.emit = function(event) {
      logger.log('socket.emit', event, Array.prototype.slice.call(arguments, 1));
      hsm.dispatch.apply(hsm, ['emit_' + event, Array.prototype.slice.call(arguments, 1)]);
    };

    const hsmOptions = (true)
      ? { debug:function(event) { hsm.logger.log(event, 'while', this.currentState().name); } }
      : {};
    this.hsm.run(hsmOptions);
  }

  login() {
    this.socket.emit('login', this.imChatInfo);
  }

  onLoginError(message) {
    this.logger.error('onLoginError()', message);
  }

  sendMessage(message) {
    this.logger.log('sendMessage()', message);
    this.socket.emit('sendMessage', message);
  }

  onMessagesList(messages) {
    this.logger.log('onMessagesList()', messages);
    this.messenger.onMessagesList(this.collocutor, messages);
  }

  onNewMessage(message) {
    this.logger.log('onNewMessage()', message);
    this.messenger.onNewMessage(this.collocutor, message);
  }

  onPerformerJoin() {
    this.logger.log('onPerformerJoin()');
    this.messenger.onPerformerJoin(this.collocutor.id);
  }

  onPerformerLeave() {
    this.logger.log('onPerformerLeave()');
    this.messenger.onPerformerLeave(this.collocutor.id);
  }

  onHsmOnlineEnter() {
    this.logger.log('onHsmOnlineEnter()');
    this.messenger.onConnectionHsmOnlineEnter(this.collocutor);
  }

  onHsmOnlineExit() {
    this.logger.log('onHsmOnlineExit()');
    this.messenger.onConnectionHsmOnlineExit(this.collocutor);
  }

  restart() {
    this.logger.info('restart()');
    this.hsm.dispatch('restart');
    this.login();
  }

}
